export default {
  "container": "_2Jxyk",
  "disabled": "_0R7k8",
  "imageInput": "zSL0L",
  "overlay": "vOIAj",
  "text": "pNmaR",
  "shown": "-WEby",
  "hide": "TYF0b",
  "spinner": "X2tKk",
  "spin": "_1lm4R"
};